module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAABG0lEQVRoge2YMWrDQBBFn4QhEN9jLpDCgTS+gH0Wk97GOLUvY5/AhbsY0krnsAPqzDqTJqybZEeMwjwQuwxoP69YgX7VNA2GbIBXoAK2wKp0lIjc1tpQYgYsgTHwqPu5VZilyFNm9mIVZimS48Hq4L5FzAgRb4SIN0LEGyHijRDxRoh4I0S8ESLe+DciI11nd/6x/8I08+4zsC4Z0rbtSUT2qQ7aaMMxZN6SyFkrmyFzqbU8GzpVrQ3g0NmOtMZ81/KsZO+ULvbkx+wDOBTM6ICjiOy+v1o7fUqyzogkiUXJkD66314JEW+EiDdCxBsh4o0Q8UaIeCNEvBEi3giRX9JZHWwpcsrMjlZhliL71ACm8gz41H3pguML4ApqnygxarxtVgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/family/icon/family_equipment_add.png
// module id = 4sTj
// module chunks = 1